/* eslint-disable */
// prettier-ignore
import type { AspidaClient } from 'aspida'
// prettier-ignore
import { dataToURLString } from 'aspida'
// prettier-ignore
import type { Methods as Methods0 } from './advance_shipments'
// prettier-ignore
import type { Methods as Methods1 } from './auth/csrf-cookie'
// prettier-ignore
import type { Methods as Methods2 } from './auth/me'
// prettier-ignore
import type { Methods as Methods3 } from './auth/signin'
// prettier-ignore
import type { Methods as Methods4 } from './auth/signout'
// prettier-ignore
import type { Methods as Methods5 } from './food_labels'
// prettier-ignore
import type { Methods as Methods6 } from './food_labels/_id@number'
// prettier-ignore
import type { Methods as Methods7 } from './invoices'
// prettier-ignore
import type { Methods as Methods8 } from './invoices/add_printout'
// prettier-ignore
import type { Methods as Methods9 } from './invoices/printout'
// prettier-ignore
import type { Methods as Methods10 } from './invoices/re_printout'
// prettier-ignore
import type { Methods as Methods11 } from './logiura'
// prettier-ignore
import type { Methods as Methods12 } from './logiura/register_logo'
// prettier-ignore
import type { Methods as Methods13 } from './manufacturers'
// prettier-ignore
import type { Methods as Methods14 } from './manufacturers/_id@number'
// prettier-ignore
import type { Methods as Methods15 } from './nextengine/redirect'
// prettier-ignore
import type { Methods as Methods16 } from './nextengine/token/expired'
// prettier-ignore
import type { Methods as Methods17 } from './nextengine/token/register'
// prettier-ignore
import type { Methods as Methods18 } from './picking_categories'
// prettier-ignore
import type { Methods as Methods19 } from './picking_categories/_id@number'
// prettier-ignore
import type { Methods as Methods20 } from './picking_categories/reorder'
// prettier-ignore
import type { Methods as Methods21 } from './picking_lists'
// prettier-ignore
import type { Methods as Methods22 } from './picking_lists/future'
// prettier-ignore
import type { Methods as Methods23 } from './printer_users'
// prettier-ignore
import type { Methods as Methods24 } from './product_components'
// prettier-ignore
import type { Methods as Methods25 } from './product_components/_id@number'
// prettier-ignore
import type { Methods as Methods26 } from './product_images'
// prettier-ignore
import type { Methods as Methods27 } from './product_types'
// prettier-ignore
import type { Methods as Methods28 } from './product_variant_images'
// prettier-ignore
import type { Methods as Methods29 } from './products'
// prettier-ignore
import type { Methods as Methods30 } from './products/_id@number'
// prettier-ignore
import type { Methods as Methods31 } from './products/_id@number/variants/_variantId@number'
// prettier-ignore
import type { Methods as Methods32 } from './products/_productID@number/variants/_variantID@number'
// prettier-ignore
import type { Methods as Methods33 } from './products/picking_categories'
// prettier-ignore
import type { Methods as Methods34 } from './products/storage_temperature_zones'
// prettier-ignore
import type { Methods as Methods35 } from './roles'
// prettier-ignore
import type { Methods as Methods36 } from './shipment_products/_id@number'
// prettier-ignore
import type { Methods as Methods37 } from './shipment_start'
// prettier-ignore
import type { Methods as Methods38 } from './shipment_statuses'
// prettier-ignore
import type { Methods as Methods39 } from './shipment_work/abort'
// prettier-ignore
import type { Methods as Methods40 } from './shipment_work/complete'
// prettier-ignore
import type { Methods as Methods41 } from './shipment_work/confirm'
// prettier-ignore
import type { Methods as Methods42 } from './shipment_work/skip'
// prettier-ignore
import type { Methods as Methods43 } from './shipment_work/start'
// prettier-ignore
import type { Methods as Methods44 } from './shipment_works'
// prettier-ignore
import type { Methods as Methods45 } from './shipments'
// prettier-ignore
import type { Methods as Methods46 } from './shipments/_id@number'
// prettier-ignore
import type { Methods as Methods47 } from './shipments/statuses/summary'
// prettier-ignore
import type { Methods as Methods48 } from './sort_codes'
// prettier-ignore
import type { Methods as Methods49 } from './storage_temperature_categories'
// prettier-ignore
import type { Methods as Methods50 } from './storage_temperature_zones'
// prettier-ignore
import type { Methods as Methods51 } from './storage_temperature_zones/_id@number'
// prettier-ignore
import type { Methods as Methods52 } from './storage_temperature_zones/reorder'
// prettier-ignore
import type { Methods as Methods53 } from './temperature_zones'
// prettier-ignore
import type { Methods as Methods54 } from './time_zones'
// prettier-ignore
import type { Methods as Methods55 } from './users'
// prettier-ignore
import type { Methods as Methods56 } from './users/_id@number'
// prettier-ignore
import type { Methods as Methods57 } from './users/password/verify'
// prettier-ignore
import type { Methods as Methods58 } from './vendors'
// prettier-ignore
import type { Methods as Methods59 } from './vendors/_id@number'

// prettier-ignore
const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '')
  const PATH0 = '/advance_shipments'
  const PATH1 = '/auth/csrf-cookie'
  const PATH2 = '/auth/me'
  const PATH3 = '/auth/signin'
  const PATH4 = '/auth/signout'
  const PATH5 = '/food_labels'
  const PATH6 = '/invoices'
  const PATH7 = '/invoices/add_printout'
  const PATH8 = '/invoices/printout'
  const PATH9 = '/invoices/re_printout'
  const PATH10 = '/logiura'
  const PATH11 = '/logiura/register_logo'
  const PATH12 = '/manufacturers'
  const PATH13 = '/nextengine/redirect'
  const PATH14 = '/nextengine/token/expired'
  const PATH15 = '/nextengine/token/register'
  const PATH16 = '/picking_categories'
  const PATH17 = '/picking_categories/reorder'
  const PATH18 = '/picking_lists'
  const PATH19 = '/picking_lists/future'
  const PATH20 = '/printer_users'
  const PATH21 = '/product_components'
  const PATH22 = '/product_images'
  const PATH23 = '/product_types'
  const PATH24 = '/product_variant_images'
  const PATH25 = '/products'
  const PATH26 = '/variants'
  const PATH27 = '/products/picking_categories'
  const PATH28 = '/products/storage_temperature_zones'
  const PATH29 = '/roles'
  const PATH30 = '/shipment_products'
  const PATH31 = '/shipment_start'
  const PATH32 = '/shipment_statuses'
  const PATH33 = '/shipment_work/abort'
  const PATH34 = '/shipment_work/complete'
  const PATH35 = '/shipment_work/confirm'
  const PATH36 = '/shipment_work/skip'
  const PATH37 = '/shipment_work/start'
  const PATH38 = '/shipment_works'
  const PATH39 = '/shipments'
  const PATH40 = '/shipments/statuses/summary'
  const PATH41 = '/sort_codes'
  const PATH42 = '/storage_temperature_categories'
  const PATH43 = '/storage_temperature_zones'
  const PATH44 = '/storage_temperature_zones/reorder'
  const PATH45 = '/temperature_zones'
  const PATH46 = '/time_zones'
  const PATH47 = '/users'
  const PATH48 = '/users/password/verify'
  const PATH49 = '/vendors'
  const GET = 'GET'
  const POST = 'POST'
  const PUT = 'PUT'
  const DELETE = 'DELETE'

  return {
    advance_shipments: {
      get: (option: { query: Methods0['get']['query'], config?: T }) =>
        fetch<Methods0['get']['resBody']>(prefix, PATH0, GET, option).json(),
      $get: (option: { query: Methods0['get']['query'], config?: T }) =>
        fetch<Methods0['get']['resBody']>(prefix, PATH0, GET, option).json().then(r => r.body),
      post: (option: { body: Methods0['post']['reqBody'], config?: T }) =>
        fetch<Methods0['post']['resBody']>(prefix, PATH0, POST, option).json(),
      $post: (option: { body: Methods0['post']['reqBody'], config?: T }) =>
        fetch<Methods0['post']['resBody']>(prefix, PATH0, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods0['get']['query'] }) =>
        `${prefix}${PATH0}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    auth: {
      csrf_cookie: {
        get: (option?: { config?: T }) =>
          fetch<Methods1['get']['resBody']>(prefix, PATH1, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods1['get']['resBody']>(prefix, PATH1, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH1}`
      },
      me: {
        get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody']>(prefix, PATH2, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody']>(prefix, PATH2, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH2}`
      },
      signin: {
        post: (option: { body: Methods3['post']['reqBody'], config?: T }) =>
          fetch<Methods3['post']['resBody']>(prefix, PATH3, POST, option).json(),
        $post: (option: { body: Methods3['post']['reqBody'], config?: T }) =>
          fetch<Methods3['post']['resBody']>(prefix, PATH3, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH3}`
      },
      signout: {
        post: (option?: { body?: Methods4['post']['reqBody'], config?: T }) =>
          fetch<Methods4['post']['resBody']>(prefix, PATH4, POST, option).json(),
        $post: (option?: { body?: Methods4['post']['reqBody'], config?: T }) =>
          fetch<Methods4['post']['resBody']>(prefix, PATH4, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH4}`
      }
    },
    food_labels: {
      _id: (val1: number) => {
        const prefix1 = `${PATH5}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods6['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods6['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods5['post']['reqBody'], config?: T }) =>
        fetch<Methods5['post']['resBody']>(prefix, PATH5, POST, option).json(),
      $post: (option: { body: Methods5['post']['reqBody'], config?: T }) =>
        fetch<Methods5['post']['resBody']>(prefix, PATH5, POST, option).json().then(r => r.body),
      put: (option: { body: Methods5['put']['reqBody'], config?: T }) =>
        fetch<Methods5['put']['resBody']>(prefix, PATH5, PUT, option).json(),
      $put: (option: { body: Methods5['put']['reqBody'], config?: T }) =>
        fetch<Methods5['put']['resBody']>(prefix, PATH5, PUT, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH5}`
    },
    invoices: {
      add_printout: {
        post: (option: { body: Methods8['post']['reqBody'], config?: T }) =>
          fetch<Methods8['post']['resBody']>(prefix, PATH7, POST, option).json(),
        $post: (option: { body: Methods8['post']['reqBody'], config?: T }) =>
          fetch<Methods8['post']['resBody']>(prefix, PATH7, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH7}`
      },
      printout: {
        post: (option: { body: Methods9['post']['reqBody'], config?: T }) =>
          fetch<Methods9['post']['resBody']>(prefix, PATH8, POST, option).json(),
        $post: (option: { body: Methods9['post']['reqBody'], config?: T }) =>
          fetch<Methods9['post']['resBody']>(prefix, PATH8, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH8}`
      },
      re_printout: {
        post: (option: { body: Methods10['post']['reqBody'], config?: T }) =>
          fetch<Methods10['post']['resBody']>(prefix, PATH9, POST, option).json(),
        $post: (option: { body: Methods10['post']['reqBody'], config?: T }) =>
          fetch<Methods10['post']['resBody']>(prefix, PATH9, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH9}`
      },
      get: (option: { query: Methods7['get']['query'], config?: T }) =>
        fetch<Methods7['get']['resBody']>(prefix, PATH6, GET, option).json(),
      $get: (option: { query: Methods7['get']['query'], config?: T }) =>
        fetch<Methods7['get']['resBody']>(prefix, PATH6, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods7['get']['query'] }) =>
        `${prefix}${PATH6}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    logiura: {
      register_logo: {
        post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
          fetch<Methods12['post']['resBody']>(prefix, PATH11, POST, option, 'FormData').json(),
        $post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
          fetch<Methods12['post']['resBody']>(prefix, PATH11, POST, option, 'FormData').json().then(r => r.body),
        $path: () => `${prefix}${PATH11}`
      },
      get: (option?: { config?: T }) =>
        fetch<Methods11['get']['resBody']>(prefix, PATH10, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods11['get']['resBody']>(prefix, PATH10, GET, option).json().then(r => r.body),
      put: (option: { body: Methods11['put']['reqBody'], config?: T }) =>
        fetch<Methods11['put']['resBody']>(prefix, PATH10, PUT, option).json(),
      $put: (option: { body: Methods11['put']['reqBody'], config?: T }) =>
        fetch<Methods11['put']['resBody']>(prefix, PATH10, PUT, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH10}`
    },
    manufacturers: {
      _id: (val1: number) => {
        const prefix1 = `${PATH12}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods14['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods14['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods14['put']['reqBody'], config?: T }) =>
            fetch<Methods14['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods14['put']['reqBody'], config?: T }) =>
            fetch<Methods14['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods14['delete']['resBody']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods14['delete']['resBody']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods13['post']['reqBody'], config?: T }) =>
        fetch<Methods13['post']['resBody']>(prefix, PATH12, POST, option).json(),
      $post: (option: { body: Methods13['post']['reqBody'], config?: T }) =>
        fetch<Methods13['post']['resBody']>(prefix, PATH12, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods13['get']['query'], config?: T }) =>
        fetch<Methods13['get']['resBody']>(prefix, PATH12, GET, option).json(),
      $get: (option?: { query?: Methods13['get']['query'], config?: T }) =>
        fetch<Methods13['get']['resBody']>(prefix, PATH12, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods13['get']['query'] }) =>
        `${prefix}${PATH12}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    nextengine: {
      redirect: {
        get: (option?: { query?: Methods15['get']['query'], config?: T }) =>
          fetch<Methods15['get']['resBody']>(prefix, PATH13, GET, option).json(),
        $get: (option?: { query?: Methods15['get']['query'], config?: T }) =>
          fetch<Methods15['get']['resBody']>(prefix, PATH13, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods15['get']['query'] }) =>
          `${prefix}${PATH13}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      token: {
        expired: {
          get: (option?: { config?: T }) =>
            fetch<Methods16['get']['resBody']>(prefix, PATH14, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods16['get']['resBody']>(prefix, PATH14, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH14}`
        },
        register: {
          post: (option: { body: Methods17['post']['reqBody'], config?: T }) =>
            fetch(prefix, PATH15, POST, option).send(),
          $post: (option: { body: Methods17['post']['reqBody'], config?: T }) =>
            fetch(prefix, PATH15, POST, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH15}`
        }
      }
    },
    picking_categories: {
      _id: (val1: number) => {
        const prefix1 = `${PATH16}/${val1}`

        return {
          put: (option: { body: Methods19['put']['reqBody'], config?: T }) =>
            fetch<Methods19['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods19['put']['reqBody'], config?: T }) =>
            fetch<Methods19['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods19['delete']['resBody']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods19['delete']['resBody']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      reorder: {
        put: (option: { body: Methods20['put']['reqBody'], config?: T }) =>
          fetch<Methods20['put']['resBody']>(prefix, PATH17, PUT, option).json(),
        $put: (option: { body: Methods20['put']['reqBody'], config?: T }) =>
          fetch<Methods20['put']['resBody']>(prefix, PATH17, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH17}`
      },
      get: (option?: { config?: T }) =>
        fetch<Methods18['get']['resBody']>(prefix, PATH16, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods18['get']['resBody']>(prefix, PATH16, GET, option).json().then(r => r.body),
      post: (option: { body: Methods18['post']['reqBody'], config?: T }) =>
        fetch<Methods18['post']['resBody']>(prefix, PATH16, POST, option).json(),
      $post: (option: { body: Methods18['post']['reqBody'], config?: T }) =>
        fetch<Methods18['post']['resBody']>(prefix, PATH16, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH16}`
    },
    picking_lists: {
      future: {
        post: (option: { body: Methods22['post']['reqBody'], config?: T }) =>
          fetch<Methods22['post']['resBody']>(prefix, PATH19, POST, option).json(),
        $post: (option: { body: Methods22['post']['reqBody'], config?: T }) =>
          fetch<Methods22['post']['resBody']>(prefix, PATH19, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH19}`
      },
      get: (option: { query: Methods21['get']['query'], config?: T }) =>
        fetch<Methods21['get']['resBody']>(prefix, PATH18, GET, option).json(),
      $get: (option: { query: Methods21['get']['query'], config?: T }) =>
        fetch<Methods21['get']['resBody']>(prefix, PATH18, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods21['get']['query'] }) =>
        `${prefix}${PATH18}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    printer_users: {
      get: (option?: { config?: T }) =>
        fetch<Methods23['get']['resBody']>(prefix, PATH20, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods23['get']['resBody']>(prefix, PATH20, GET, option).json().then(r => r.body),
      post: (option: { body: Methods23['post']['reqBody'], config?: T }) =>
        fetch<Methods23['post']['resBody']>(prefix, PATH20, POST, option).json(),
      $post: (option: { body: Methods23['post']['reqBody'], config?: T }) =>
        fetch<Methods23['post']['resBody']>(prefix, PATH20, POST, option).json().then(r => r.body),
      delete: (option: { body: Methods23['delete']['reqBody'], config?: T }) =>
        fetch(prefix, PATH20, DELETE, option).send(),
      $delete: (option: { body: Methods23['delete']['reqBody'], config?: T }) =>
        fetch(prefix, PATH20, DELETE, option).send().then(r => r.body),
      $path: () => `${prefix}${PATH20}`
    },
    product_components: {
      _id: (val1: number) => {
        const prefix1 = `${PATH21}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods25['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods25['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods24['post']['reqBody'], config?: T }) =>
        fetch<Methods24['post']['resBody']>(prefix, PATH21, POST, option, 'FormData').json(),
      $post: (option: { body: Methods24['post']['reqBody'], config?: T }) =>
        fetch<Methods24['post']['resBody']>(prefix, PATH21, POST, option, 'FormData').json().then(r => r.body),
      $path: () => `${prefix}${PATH21}`
    },
    product_images: {
      post: (option: { body: Methods26['post']['reqBody'], config?: T }) =>
        fetch<Methods26['post']['resBody']>(prefix, PATH22, POST, option, 'FormData').json(),
      $post: (option: { body: Methods26['post']['reqBody'], config?: T }) =>
        fetch<Methods26['post']['resBody']>(prefix, PATH22, POST, option, 'FormData').json().then(r => r.body),
      $path: () => `${prefix}${PATH22}`
    },
    product_types: {
      get: (option?: { config?: T }) =>
        fetch<Methods27['get']['resBody']>(prefix, PATH23, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods27['get']['resBody']>(prefix, PATH23, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH23}`
    },
    product_variant_images: {
      post: (option: { body: Methods28['post']['reqBody'], config?: T }) =>
        fetch<Methods28['post']['resBody']>(prefix, PATH24, POST, option, 'FormData').json(),
      $post: (option: { body: Methods28['post']['reqBody'], config?: T }) =>
        fetch<Methods28['post']['resBody']>(prefix, PATH24, POST, option, 'FormData').json().then(r => r.body),
      $path: () => `${prefix}${PATH24}`
    },
    products: {
      _id: (val1: number) => {
        const prefix1 = `${PATH25}/${val1}`

        return {
          variants: {
            _variantId: (val3: number) => {
              const prefix3 = `${prefix1}${PATH26}/${val3}`

              return {
                put: (option: { body: Methods31['put']['reqBody'], config?: T }) =>
                  fetch<Methods31['put']['resBody']>(prefix, prefix3, PUT, option).json(),
                $put: (option: { body: Methods31['put']['reqBody'], config?: T }) =>
                  fetch<Methods31['put']['resBody']>(prefix, prefix3, PUT, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}`
              }
            }
          },
          get: (option?: { config?: T }) =>
            fetch<Methods30['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods30['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods30['put']['reqBody'], config?: T }) =>
            fetch<Methods30['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods30['put']['reqBody'], config?: T }) =>
            fetch<Methods30['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      _productID: (val1: number) => {
        const prefix1 = `${PATH25}/${val1}`

        return {
          variants: {
            _variantID: (val3: number) => {
              const prefix3 = `${prefix1}${PATH26}/${val3}`

              return {
                put: (option: { body: Methods32['put']['reqBody'], config?: T }) =>
                  fetch<Methods32['put']['resBody']>(prefix, prefix3, PUT, option).json(),
                $put: (option: { body: Methods32['put']['reqBody'], config?: T }) =>
                  fetch<Methods32['put']['resBody']>(prefix, prefix3, PUT, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}`
              }
            }
          }
        }
      },
      picking_categories: {
        get: (option?: { query?: Methods33['get']['query'], config?: T }) =>
          fetch<Methods33['get']['resBody']>(prefix, PATH27, GET, option).json(),
        $get: (option?: { query?: Methods33['get']['query'], config?: T }) =>
          fetch<Methods33['get']['resBody']>(prefix, PATH27, GET, option).json().then(r => r.body),
        put: (option: { body: Methods33['put']['reqBody'], config?: T }) =>
          fetch<Methods33['put']['resBody']>(prefix, PATH27, PUT, option).json(),
        $put: (option: { body: Methods33['put']['reqBody'], config?: T }) =>
          fetch<Methods33['put']['resBody']>(prefix, PATH27, PUT, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods33['get']['query'] }) =>
          `${prefix}${PATH27}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      storage_temperature_zones: {
        get: (option?: { query?: Methods34['get']['query'], config?: T }) =>
          fetch<Methods34['get']['resBody']>(prefix, PATH28, GET, option).json(),
        $get: (option?: { query?: Methods34['get']['query'], config?: T }) =>
          fetch<Methods34['get']['resBody']>(prefix, PATH28, GET, option).json().then(r => r.body),
        put: (option: { body: Methods34['put']['reqBody'], config?: T }) =>
          fetch<Methods34['put']['resBody']>(prefix, PATH28, PUT, option).json(),
        $put: (option: { body: Methods34['put']['reqBody'], config?: T }) =>
          fetch<Methods34['put']['resBody']>(prefix, PATH28, PUT, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods34['get']['query'] }) =>
          `${prefix}${PATH28}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option: { query: Methods29['get']['query'], config?: T }) =>
        fetch<Methods29['get']['resBody']>(prefix, PATH25, GET, option).json(),
      $get: (option: { query: Methods29['get']['query'], config?: T }) =>
        fetch<Methods29['get']['resBody']>(prefix, PATH25, GET, option).json().then(r => r.body),
      post: (option?: { config?: T }) =>
        fetch<Methods29['post']['resBody']>(prefix, PATH25, POST, option).json(),
      $post: (option?: { config?: T }) =>
        fetch<Methods29['post']['resBody']>(prefix, PATH25, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods29['get']['query'] }) =>
        `${prefix}${PATH25}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    roles: {
      get: (option?: { config?: T }) =>
        fetch<Methods35['get']['resBody']>(prefix, PATH29, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods35['get']['resBody']>(prefix, PATH29, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH29}`
    },
    shipment_products: {
      _id: (val1: number) => {
        const prefix1 = `${PATH30}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods36['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods36['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      }
    },
    shipment_start: {
      post: (option?: { config?: T }) =>
        fetch<Methods37['post']['resBody']>(prefix, PATH31, POST, option).json(),
      $post: (option?: { config?: T }) =>
        fetch<Methods37['post']['resBody']>(prefix, PATH31, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH31}`
    },
    shipment_statuses: {
      get: (option?: { config?: T }) =>
        fetch<Methods38['get']['resBody']>(prefix, PATH32, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods38['get']['resBody']>(prefix, PATH32, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH32}`
    },
    shipment_work: {
      abort: {
        post: (option: { body: Methods39['post']['reqBody'], config?: T }) =>
          fetch<Methods39['post']['resBody']>(prefix, PATH33, POST, option).json(),
        $post: (option: { body: Methods39['post']['reqBody'], config?: T }) =>
          fetch<Methods39['post']['resBody']>(prefix, PATH33, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH33}`
      },
      complete: {
        post: (option: { body: Methods40['post']['reqBody'], config?: T }) =>
          fetch<Methods40['post']['resBody']>(prefix, PATH34, POST, option).json(),
        $post: (option: { body: Methods40['post']['reqBody'], config?: T }) =>
          fetch<Methods40['post']['resBody']>(prefix, PATH34, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH34}`
      },
      confirm: {
        post: (option: { body: Methods41['post']['reqBody'], config?: T }) =>
          fetch<Methods41['post']['resBody']>(prefix, PATH35, POST, option).json(),
        $post: (option: { body: Methods41['post']['reqBody'], config?: T }) =>
          fetch<Methods41['post']['resBody']>(prefix, PATH35, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH35}`
      },
      skip: {
        post: (option: { body: Methods42['post']['reqBody'], config?: T }) =>
          fetch<Methods42['post']['resBody']>(prefix, PATH36, POST, option).json(),
        $post: (option: { body: Methods42['post']['reqBody'], config?: T }) =>
          fetch<Methods42['post']['resBody']>(prefix, PATH36, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH36}`
      },
      start: {
        post: (option: { body: Methods43['post']['reqBody'], config?: T }) =>
          fetch<Methods43['post']['resBody']>(prefix, PATH37, POST, option).json(),
        $post: (option: { body: Methods43['post']['reqBody'], config?: T }) =>
          fetch<Methods43['post']['resBody']>(prefix, PATH37, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH37}`
      }
    },
    shipment_works: {
      get: (option: { query: Methods44['get']['query'], config?: T }) =>
        fetch<Methods44['get']['resBody']>(prefix, PATH38, GET, option).json(),
      $get: (option: { query: Methods44['get']['query'], config?: T }) =>
        fetch<Methods44['get']['resBody']>(prefix, PATH38, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods44['get']['query'] }) =>
        `${prefix}${PATH38}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    shipments: {
      _id: (val1: number) => {
        const prefix1 = `${PATH39}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods46['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods46['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods46['put']['reqBody'], config?: T }) =>
            fetch<Methods46['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods46['put']['reqBody'], config?: T }) =>
            fetch<Methods46['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      statuses: {
        summary: {
          get: (option: { query: Methods47['get']['query'], config?: T }) =>
            fetch<Methods47['get']['resBody']>(prefix, PATH40, GET, option).json(),
          $get: (option: { query: Methods47['get']['query'], config?: T }) =>
            fetch<Methods47['get']['resBody']>(prefix, PATH40, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods47['get']['query'] }) =>
            `${prefix}${PATH40}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        }
      },
      get: (option: { query: Methods45['get']['query'], config?: T }) =>
        fetch<Methods45['get']['resBody']>(prefix, PATH39, GET, option).json(),
      $get: (option: { query: Methods45['get']['query'], config?: T }) =>
        fetch<Methods45['get']['resBody']>(prefix, PATH39, GET, option).json().then(r => r.body),
      post: (option: { body: Methods45['post']['reqBody'], config?: T }) =>
        fetch<Methods45['post']['resBody']>(prefix, PATH39, POST, option).json(),
      $post: (option: { body: Methods45['post']['reqBody'], config?: T }) =>
        fetch<Methods45['post']['resBody']>(prefix, PATH39, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods45['get']['query'] }) =>
        `${prefix}${PATH39}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    sort_codes: {
      post: (option: { body: Methods48['post']['reqBody'], config?: T }) =>
        fetch<Methods48['post']['resBody']>(prefix, PATH41, POST, option).json(),
      $post: (option: { body: Methods48['post']['reqBody'], config?: T }) =>
        fetch<Methods48['post']['resBody']>(prefix, PATH41, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH41}`
    },
    storage_temperature_categories: {
      get: (option?: { config?: T }) =>
        fetch<Methods49['get']['resBody']>(prefix, PATH42, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods49['get']['resBody']>(prefix, PATH42, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH42}`
    },
    storage_temperature_zones: {
      _id: (val1: number) => {
        const prefix1 = `${PATH43}/${val1}`

        return {
          put: (option: { body: Methods51['put']['reqBody'], config?: T }) =>
            fetch<Methods51['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods51['put']['reqBody'], config?: T }) =>
            fetch<Methods51['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods51['delete']['resBody']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods51['delete']['resBody']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      reorder: {
        put: (option: { body: Methods52['put']['reqBody'], config?: T }) =>
          fetch<Methods52['put']['resBody']>(prefix, PATH44, PUT, option).json(),
        $put: (option: { body: Methods52['put']['reqBody'], config?: T }) =>
          fetch<Methods52['put']['resBody']>(prefix, PATH44, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH44}`
      },
      get: (option?: { config?: T }) =>
        fetch<Methods50['get']['resBody']>(prefix, PATH43, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods50['get']['resBody']>(prefix, PATH43, GET, option).json().then(r => r.body),
      post: (option: { body: Methods50['post']['reqBody'], config?: T }) =>
        fetch<Methods50['post']['resBody']>(prefix, PATH43, POST, option).json(),
      $post: (option: { body: Methods50['post']['reqBody'], config?: T }) =>
        fetch<Methods50['post']['resBody']>(prefix, PATH43, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH43}`
    },
    temperature_zones: {
      get: (option?: { config?: T }) =>
        fetch<Methods53['get']['resBody']>(prefix, PATH45, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods53['get']['resBody']>(prefix, PATH45, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH45}`
    },
    time_zones: {
      get: (option: { query: Methods54['get']['query'], config?: T }) =>
        fetch<Methods54['get']['resBody']>(prefix, PATH46, GET, option).json(),
      $get: (option: { query: Methods54['get']['query'], config?: T }) =>
        fetch<Methods54['get']['resBody']>(prefix, PATH46, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods54['get']['query'] }) =>
        `${prefix}${PATH46}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    users: {
      _id: (val1: number) => {
        const prefix1 = `${PATH47}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods56['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods56['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods56['put']['reqBody'], config?: T }) =>
            fetch<Methods56['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods56['put']['reqBody'], config?: T }) =>
            fetch<Methods56['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods56['delete']['resBody']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods56['delete']['resBody']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      password: {
        verify: {
          post: (option: { body: Methods57['post']['reqBody'], config?: T }) =>
            fetch<Methods57['post']['resBody']>(prefix, PATH48, POST, option).json(),
          $post: (option: { body: Methods57['post']['reqBody'], config?: T }) =>
            fetch<Methods57['post']['resBody']>(prefix, PATH48, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH48}`
        }
      },
      post: (option: { body: Methods55['post']['reqBody'], config?: T }) =>
        fetch<Methods55['post']['resBody']>(prefix, PATH47, POST, option).json(),
      $post: (option: { body: Methods55['post']['reqBody'], config?: T }) =>
        fetch<Methods55['post']['resBody']>(prefix, PATH47, POST, option).json().then(r => r.body),
      get: (option: { query: Methods55['get']['query'], config?: T }) =>
        fetch<Methods55['get']['resBody']>(prefix, PATH47, GET, option).json(),
      $get: (option: { query: Methods55['get']['query'], config?: T }) =>
        fetch<Methods55['get']['resBody']>(prefix, PATH47, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods55['get']['query'] }) =>
        `${prefix}${PATH47}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    vendors: {
      _id: (val1: number) => {
        const prefix1 = `${PATH49}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods59['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods59['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods59['put']['reqBody'], config?: T }) =>
            fetch<Methods59['put']['resBody']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods59['put']['reqBody'], config?: T }) =>
            fetch<Methods59['put']['resBody']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods59['delete']['resBody']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods59['delete']['resBody']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods58['post']['reqBody'], config?: T }) =>
        fetch<Methods58['post']['resBody']>(prefix, PATH49, POST, option).json(),
      $post: (option: { body: Methods58['post']['reqBody'], config?: T }) =>
        fetch<Methods58['post']['resBody']>(prefix, PATH49, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods58['get']['query'], config?: T }) =>
        fetch<Methods58['get']['resBody']>(prefix, PATH49, GET, option).json(),
      $get: (option?: { query?: Methods58['get']['query'], config?: T }) =>
        fetch<Methods58['get']['resBody']>(prefix, PATH49, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods58['get']['query'] }) =>
        `${prefix}${PATH49}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    }
  }
}

// prettier-ignore
export type ApiInstance = ReturnType<typeof api>
// prettier-ignore
export default api
